import { render, staticRenderFns } from "./classExample.vue?vue&type=template&id=38046f74&scoped=true&"
import script from "./classExample.vue?vue&type=script&lang=js&"
export * from "./classExample.vue?vue&type=script&lang=js&"
import style0 from "./classExample.vue?vue&type=style&index=0&id=38046f74&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38046f74",
  null
  
)

export default component.exports